import { t } from "./to-string-tag-support.js";
import { c as o } from "./classof.js";
var r = t ? {}.toString : function () {
  return "[object " + o(this) + "]";
};
export { r as o };